import React, { useState, useRef, useEffect } from "react";
import { normalizeString } from "../utils/gameUtils";

function GuessInput({
  playerList,
  guessedPlayers,
  onSubmitGuess,
  disabled,
}) {
  const [value, setValue] = useState("");
  const [matches, setMatches] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const query = normalizeString(e.target.value.trim());
    setValue(e.target.value);
    setHighlightedIndex(-1);
    if (query.length === 0) {
      setMatches([]);
      setShowSuggestions(false);
      return;
    }
    const filtered = playerList.filter(
      (p) =>
        normalizeString(p.displayName).includes(query) &&
        !guessedPlayers.includes(p.displayName)
    );
    const nextMatches = filtered.slice(0, 5);
    setMatches(nextMatches);
    setShowSuggestions(nextMatches.length > 0);
  };

  const submitGuess = (player) => {
    const name = player ? player.displayName : value.trim();
    const normalized = normalizeString(name);
    const guessData = playerList.find(
      (p) => normalizeString(p.displayName) === normalized
    );
    if (!guessData) return;
    setValue("");
    setMatches([]);
    setShowSuggestions(false);
    setHighlightedIndex(-1);
    onSubmitGuess(guessData);
  };

  const handleKeyDown = (e) => {
    if (!showSuggestions || matches.length === 0) {
      if (e.key === "Enter") submitGuess(null);
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((i) => (i + 1) % matches.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((i) => (i <= 0 ? matches.length - 1 : i - 1));
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      e.preventDefault();
      submitGuess(matches[highlightedIndex]);
    }
  };

  return (
    <div className="input-area" ref={wrapperRef}>
      <div className="input-wrapper">
        <input
          type="text"
          className="guess-input"
          placeholder="Guess the player"
          autoComplete="off"
          value={value}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          aria-label="Guess the player"
        />
        {showSuggestions && (
          <div className="suggestions-list" id="suggestions-list">
            {matches.map((p, i) => (
              <div
                key={p.displayName}
                className={`suggestion-item ${i === highlightedIndex ? "highlighted" : ""}`}
                onClick={() => submitGuess(p)}
                onMouseEnter={() => setHighlightedIndex(i)}
              >
                {p.displayName}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default GuessInput;
